import { AnaColumn } from "../forms-template.service";

export const esportaForm : AnaColumn[]=[
    {
        itemType: "group", groupDataField: 'esportaProduttori', caption:'', colCount: "3", data: [
      {
        class:'listaExport',
        type: 'campoSpecial', disableOnUpdate: false,disabled:true, width: "210px", dataField: "sottoGruppi", editorType: "dxSelectBox",

        validation: [{ type: "required", message: "Campo Obbligatorio" }],
        caption: "",
        lista: {
          dataSource: 'sottoGruppi',
          displayExpr: 'descrizione',
          valueExpr: 'id',       
          static: true
        }
      },
      {
        class:'listaExport',
        type: 'simpleButton', dataField: "sfogliaVariabili",
        colVisible: false,
        button: {
          text: 'Cerca',
          name: "sfogliaVariabili",
          event: "sfogliaVariabili",
          type: "normal",
          hint: "Sfoglia Gruppo di Variabili",
          //related: ['latidudine', 'longitudine'],
        }
      },
      { type: 'empty', colVisible: false, caption: '', dataField: '', dataType: '' }
    ]
  },
  {
  itemType: "group", groupDataField: 'trasferisci', caption:'', colCount: "1", class:'esportaCentrato',data: [
      {
        type: 'simpleButton',
        dataField: "trasferisciColonne",
        
        colVisible: false,
        class:'trasferisciColonne blueButton',
        button: {
          text: '',
          icon:'chevrondoubleright',
          name: "trasferisciColonne",
          event: "trasferisciColonne",
          type: "normal",
          hint: "Trasferisci colonne per la stampa",
          class:'blueButton'
          //related: ['latidudine', 'longitudine'],
        }
      },

    ]
  },
  
  
];
